import Vue from 'vue';
import Vuex from 'vuex';
import { SET, SET_ITEM } from './mutations';
import { app, giftcard, search, treatment, user, clickAndCollect, webshop, userBehavior, campaigns, webshopCore, reward, site, checkout, favorites } from './modules';

Vue.use(Vuex);

export default new Vuex.Store({
	strict: process.env.NODE_ENV === 'development',
	// Modules
	modules: {
		app,
		giftcard,
		search,
		treatment,
		user,
		userBehavior,

		// Webshop
		clickAndCollect,
		webshop,
		webshopCore,
		checkout,

		campaigns,
		reward,
		site,
		favorites
	},

	// Global
	state: {},
	mutations: {},
	actions: {}
});

export { SET, SET_ITEM };
